
export function getStateFromPostcode(postcode) {
  // https://en.wikipedia.org/wiki/Postcodes_in_Australia
  let _p = parseInt(postcode);
  if ((_p >= 1000 && _p <= 2599) || (_p >= 2619 && _p <= 2899) || (_p >= 2921 && _p <= 2999)) { return "NSW"; }
  if ((_p >= 200 && _p <= 299) || (_p >= 2600 && _p <= 2618) || (_p >= 2900 && _p <= 2920)) { return "ACT"; }
  if ((_p >= 3000 && _p <= 3999) || (_p >= 8000 && _p <= 8999)) { return "VIC"; }
  if ((_p >= 4000 && _p <= 4999) || (_p >= 9000 && _p <= 9999)) { return "QLD"; }
  if (_p >= 5000 && _p <= 5999) { return "SA"; }
  if (_p >= 6000 && _p <= 6999) { return "WA"; }
  if (_p >= 7000 && _p <= 7999) { return "TAS"; }
  if (_p >= 800 && _p <= 999) { return "NT"; }
  return null;
}
